import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import { env } from "env";
import useTranslation from "utils/hooks/useTranslation";
import numeral from "numeral";
import { useAppSelector } from "store/hooks";
import { useCallback, useEffect, useState } from "react";
import { CHART_COLOR_NEW, CHART_LINECHART_OPTIONS, DARKEN_CHART_COLOR } from "configApp";
import { useProject } from "utils/hooks/useProject";



interface ProductModalContentProps {
    data?: any
}



const ProductModalContent4: React.FC<ProductModalContentProps> = ({ data }) => {
    const { t } = useTranslation();
    const { network } = useSalesNetwork();
    const projectStore = useAppSelector((state) => state.project);
    const [, setWindowSize] = useState<number>(); // NOSONAR
    const { isHybride, getValue } = useProject();
    const deperds_TBase = +getValue("forms.heatModeStep.form.tbase");

    let ApointFound = false;

    const barChartOptions = {
        ...CHART_LINECHART_OPTIONS, ...{
            title: t('BARCHART_OPERATION'),
            series: {
                0: { targetAxisIndex: 1, type: 'area' },
                1: {
                    targetAxisIndex: 0, type: 'area', areaOpacity: 0.3,

                },
                2: { targetAxisIndex: 0, type: 'area', areaOpacity: 0.1 },
                3: { targetAxisIndex: 0 },
            },
            hAxis: {
                title: t('EXT_TEMP'),
                titleTextStyle: { italic: false },
            },
            vAxes: {
                0: {
                    title: t('GRAPH_DEPER'), //'Deperditions (kW)',
                    titleTextStyle: { color: DARKEN_CHART_COLOR[1], italic: false },
                    textStyle: { color: DARKEN_CHART_COLOR[1] },
                },
                1: {
                    title: t('GRAPH_TIME_YEAR'), //'Heures/an',
                    titleTextStyle: { color: DARKEN_CHART_COLOR[0], italic: false },
                    textStyle: { color: DARKEN_CHART_COLOR[0] },
                }
            }
        }
    };

    const fonctionnementItem = useCallback((title: string, value: any, secondLabel: string = "") => {
        return (
            <group data-gap="10" data-wrap="no" data-min-height="30">
                {secondLabel && <group data-width="auto" data-align="baseline" data-space-vertical="2">
                    <text data-type="group" data-length="20" data-height="20" data-background="main" data-color="white" data-radius="20" data-justify="center" data-align="center" data-text-size="14">{secondLabel}</text>
                </group>}
                <group data-width="auto">
                    <text data-wrap="wrap">{title}{" :"} <text data-weight="600" >{value}</text></text>
                </group>

            </group>
        )
    }, [])

    const getLegend = useCallback((title: string, color: string) => {
        return (
            <group data-direction="row" data-gap="5" data-align="start" data-wrap="no" >
                <group data-width="auto" >
                    <svg width="25" height="25" >
                        <g>
                            <rect x="0" y="4" width="25" height="11" stroke="none" stroke-width="0" fill-opacity="0" fill="#ffffff"></rect>
                            <rect x="0" y="6.5" width="22" height="6" stroke="none" stroke-width="0" fill-opacity="0.3" fill={color}></rect>
                            <path d="M0,6.5L22,6.5" stroke={color} stroke-width="2" fill-opacity="0.1" fill="none"></path>
                        </g>
                    </svg>
                </group>

                <text text-anchor="start" font-family="Arial" stroke-width="0" data-wrap="wrap" data-align="center">
                    {t(title)}
                </text>
            </group>
        )
    }, [t])

    // const fonctionnementItemOld = useCallback((title: string, value: any, secondLabel: string = "") => {
    //     return (
    //         <group data-gap="5" data-wrap="nowrap" data-align="end">
    //             <group data-wrap="nowrap" data-width="auto" data-align="end" data-gap="5" data-min-height="30">
    //                 <text data-wrap="wrap" data-length="autofit">{title}{!secondLabel && " :"}</text>
    //                 {secondLabel && <text data-type="group" data-length="20" data-height="20" data-background="main" data-color="white" data-radius="20" data-justify="center" data-align="center" data-text-size="14">{secondLabel}</text>}
    //                 {secondLabel && <text>:</text>}
    //             </group>
    //             <text data-bottom="-3" data-text-size="large" data-weight="600" data-min-height="30" data-type="group" data-width="auto" data-align="end">{value}</text>
    //         </group>
    //     )
    // }, [])

    const getAnnotation = (row: any, serie: any) => {
        if (deperds_TBase === row.Temp) return serie === 'Power' ? 'A' : 'B';
        else if (!ApointFound && row.Power && row.Needs && +parseFloat(row.Power).toFixed(1) === +parseFloat(row.Needs).toFixed(1)) {
            ApointFound = true;
            return 'C';
        }
        if (row.Temp === 16 && serie === 'Needs') return 'D';
        return null;
    };


    const drawChartFonctionnement = (conso: any) => { // NOSONAR
        let chartData;
        const _barChartOptions = { ...barChartOptions };

        if (projectStore.project.simulationCool) {
            // @ts-ignore
            _barChartOptions.series[4] = { targetAxisIndex: 0 };
            // @ts-ignore
            _barChartOptions.series[5] = { targetAxisIndex: 0 };

            chartData = [
                [t('TEMPERATURE'), t('HOURS'), t('POWER'), { role: 'annotation' }, t('NEEDS'), { role: 'annotation' }, t('COOL_NEEDS'), t('COOL_POWER')],
                //['-7', 100],
            ];
        } else { // NOSONAR
            chartData = [
                [t('TEMPERATURE'), t('HOURS'), t('POWER'), { role: 'annotation' }, t('NEEDS'), { role: 'annotation' }],
                //['-7', 100],
            ];
        }

        ApointFound = false;

        let rowdata = null;
        conso?.forEach((item: any, index: number) => {
            const nextIndex = Math.min(index + 1, conso.length - 1);
            const prevIndex = Math.max(index - 1, 0);
            let row = { ...item };

            console.log(row)
            row.Power = row.Power || (conso[nextIndex].Power > 0 || conso[prevIndex].Power > 0) ? row.Power : null; // NOSONAR
            row.Needs = row.Needs || (conso[nextIndex].Needs > 0 || conso[prevIndex].Needs > 0) ? row.Needs : null; // NOSONAR
            row.FRNeed = row.FRNeed || (conso[nextIndex].FRNeed > 0 || conso[prevIndex].FRNeed > 0) ? row.FRNeed : null; // NOSONAR
            row.ColdMaxPower = row.ColdMaxPower || (conso[nextIndex].ColdMaxPower > 0 || conso[prevIndex].ColdMaxPower > 0) ? row.ColdMaxPower : null;// NOSONAR
            if (row.Power) row.Power = +parseFloat(row.Power).toFixed(2); // NOSONAR
            if (row.Needs) row.Needs = +parseFloat(row.Needs).toFixed(2); // NOSONAR
            if (row.FRNeed) row.FRNeed = +parseFloat(row.FRNeed).toFixed(2); // NOSONAR
            if (row.ColdMaxPower) row.ColdMaxPower = +parseFloat(row.ColdMaxPower).toFixed(2); // NOSONAR

            if ((!projectStore.project.simulationCool &&
                (row.Temp <= (parseInt(projectStore.project.forms.heatModeStep.form?.deperditions?.temperature))
                    || row.Temp < 100
                )
            ) // NOSONAR
                || projectStore.project.simulationCool) {
                const annotationPower = getAnnotation(row, 'Power');
                const annotationNeeds = getAnnotation(row, 'Needs');
                let annotation = null;

                console.log(annotationPower);

                if (annotationPower && annotationNeeds && row.Power && row.Needs && row.Power?.round(1) === row.Needs.round(1)) { // NOSONAR
                    annotation = annotationPower + ' / ' + annotationNeeds;
                }

                rowdata = [
                    row.Temp,
                    row.NbOfHours,
                    row.Power,
                    annotation || annotationPower,
                    row.Needs > 0 || row.Temp === 16 ? row.Needs - (row.Needs > 0.5 ? 0.05 : 0) : null, // series[1]
                    annotation || annotationNeeds]; // NOSONAR
                if (projectStore.project.simulationCool) { // NOSONAR
                    rowdata.push(row.FRNeed);
                    rowdata.push(row.ColdMaxPower);
                }

                chartData.push(rowdata);
            }
        });


        // @ts-ignore
        const data = new window.google.visualization.arrayToDataTable(chartData);
        // @ts-ignore
        const chart = new window.google.visualization.LineChart(document.getElementById('chartFonc'));
        chart.draw(data, _barChartOptions);
    };

    useEffect(() => {
        drawChartFonctionnement(data.E2); // NOSONAR
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        // Fix a bug on smartphone to adapt first chart to screen size
        setTimeout(() => {
            setWindowSize(window.innerWidth);
        }, 100)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleResize = useCallback(() => {
        // @ts-ignore
        delete barChartOptions.animation;
        setWindowSize(window.innerWidth);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        return () => {
            window.removeEventListener("resize", handleResize);
        }
    }, [handleResize]);

    return (
        <>
            <group
                data-gap="30"
                data-text-size="medium"
                data-space-vertical="30"
                data-space-horizontal="50"
                data-direction="column"
                data-justify="start"

            >
                <group data-align="start" data-gap="20" data-direction="column">

                    <group data-wrap="no" data-space-vertical="10" data-gap="20" data-length="autofit" data-max-length="1440">
                        <group data-height="50" data-length="5" data-background="main"></group>
                        <group data-length="autofit" data-align="center">
                            <text data-text-size="22" data-weight="600">{t("PRODCTMODAL_MENU_2")}</text>
                        </group>
                    </group>


                    <group
                        data-width="autofit"

                        data-gap="30"
                        data-text-size="medium"
                        data-space-vertical="20"
                    >

                        <group data-direction="column" data-length="forcefit" data-fit="1" data-max-length="50%" data-justify="start" data-gap="5">
                            {
                                fonctionnementItem(t('BASE_TEMPERATURE'), (deperds_TBase as any).round(0))
                            }
                            {
                                isHybride() ? fonctionnementItem(t('PCALO_A0W50'), numeral(data.Pcalotb * 1000).format('0,0')) : fonctionnementItem(t('TBASE_HEATING_POWER'), numeral(data.Pcalotb * 1000).format('0,0'), "A")
                            }
                            {
                                fonctionnementItem(t('ESTIMATED_LOSS'), numeral(projectStore.project.deperds?.Deperd).format('0,0'), "B")
                            }
                            {
                                fonctionnementItem(t('BIVALENCE_POINT'), data.Tbiv, "C")
                            }
                            {

                                fonctionnementItem(t('GRAPH_PONTED'), 16, "D")
                            }

                        </group>



                        <group data-direction="column" data-length="forcefit" data-fit="1" data-max-length="50%" data-justify="start" data-gap="5">
                            {

                                fonctionnementItem(t('EXTRA_ELEC'), numeral(data.AppointAvailable).format())
                            }
                            {
                                fonctionnementItem(t('NEEDED_EXTRA_ELEC'), numeral(data.AppointNeeded).format())
                            }
                            {
                                fonctionnementItem(t('ANNUAL_THERMO_COV_RATE'), data.TxCouvThermo)
                            }
                            {
                                fonctionnementItem(t(projectStore.project.forms.hpChoiceStep.form?.typeECS === 'sans' ? 'ESTM_TOTAL_CONS_WITHOUT_ECS' : 'ESTM_TOTAL_CONS', { currency: network?._parameters.currency }), numeral(data.AllConso).format())
                            }
                            {
                                fonctionnementItem(isHybride() ? t("PABS_A0W50") : t("PABS_TITLE"), projectStore.project.results.E1?.[0]?.Pconso_Tb_kWh)
                            }
                        </group>

                    </group>




                    <group data-text-size="12" data-space-horizontal="70">
                        {getLegend("HOURS", CHART_COLOR_NEW[0])}
                        {getLegend("NEEDS", CHART_COLOR_NEW[2])}
                        {getLegend("POWER", CHART_COLOR_NEW[1])}

                        {projectStore.project.simulationCool &&
                            <>
                                {getLegend("COOL_NEEDS", CHART_COLOR_NEW[3])}
                                {getLegend("COOL_POWER", CHART_COLOR_NEW[4])}
                            </>
                        }

                    </group>
                    <group
                        data-name="chart-holder"
                        data-height="450"
                    //data-length="autofit"
                    //data-space-vertical="50"
                    //data-background="grey-color-light"
                    >
                        <group data-length="autofit" id="chartFonc" />
                    </group>
                    <group data-border-color="border-color" data-border="2" data-color="blue" data-space="10" >
                        <group data-text-size="10" data-gap="10" data-color="black" data-direction="column">
                            <text data-wrap="wrap">
                                {t("GRAPH_A")}
                                {/* A = Puissance de chauffage en kW fournie par la pompe a chaleur pour chauffer le logement lorsque la temperature exterieure atteint la temperature de base* de votre lieu d'habitation. */}
                            </text>
                            <text data-wrap="wrap">
                                {t("GRAPH_B")}
                                {/* B = Besoin de chauffage du logement exprimé en kW, calculé pour la température de base* de votre lieu d'habitation. */}
                            </text>
                            <text data-wrap="wrap">
                                {t("GRAPH_C")}
                                {/* C = Point de bivalence correspondant a la temperature exterieure a partir de laquelle un appoint de chauffage sera sollicite. En pompe a chaleur seule, l'utilisation de l'appoint electrique reste
                                marginale et ne fonctionne qu'en cas de froid extreme. En configuration hybride ou avec releve de chaudiere, l'appoint est assure par la chaudiere. La bascule s'opere lorsque l'utilisation de celle-
                                ci devient plus pertinente que celle de la pompe à chaleur, selon un critère de performance (COP) ou d'économie d'énergie). */}
                            </text>
                            <text data-wrap="wrap">
                                {t("GRAPH_D")}
                                {/* D = Temperature extérieure à partir de laquelle les apports gratuits ** de chaleur couvrent les besoins de chauffage du logement. Dans cette situation, la pompe à chaleur n'est plus sollicitée. */}
                            </text>
                            <group data-direction="column">
                                <text data-wrap="wrap">
                                    {t("GRAPH_COMMENT1")}
                                    {/* * La temperature de base est une valeur de reference utilisee pour le dimensionnement des pompes à chaleur. Elle correspond à la moyenne des températures minimales enregistrées sur une
                                    periode de trente ans, avec un minimum de cinq jours par an. */}
                                </text>
                                <text data-wrap="wrap">
                                    {t("GRAPH_COMMENT2")}
                                    {/* ** Les apports gratuits designent l'ensemble des sources de chaleur naturelle ou interne qui rechauffent le logement sans solliciter le systeme de chauffage, comme le rayonnement solaire à
                                    travers les vitrages, la chaleur degagee par les occupants ou encore le fonctionnement des appareils électriques. */}
                                </text>
                            </group>
                        </group>
                    </group>

                </group>
            </group>
        </>
    )
}

export default ProductModalContent4;